export default [




  {
    path: '/discount/list/',
    name: 'discount-list',
    component: () => import('@/modules/discount/list/listDiscounts'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
  {
    path: '/discount/add/',
    name: 'discount-add',
    component: () => import('@/modules/discount/add/addDiscountCode'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
  {
    path: '/discount/edit/:id',
    name: 'discount-edit',
    component: () => import('@/modules/discount/edit/editDiscountCode'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
]
